<div class="container" style="padding: 3em">
    <div class="row justify-content-center">
        <div class="col-5">
            <div class="card">
                <h4 class="card-header">Login</h4>
                <div class="card-body">
                    <form [formGroup]="form" (ngSubmit)="login()">
                        <div class="form-group">
                            <label for="username">User Name</label>
                            <input type="text" formControlName="username" placeholder="Enter User Name" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" (keyup)="resetError()" />
                            <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                                <div *ngIf="f.username.errors.required">Username is required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="password">Password</label>
                            <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" (keyup)="resetError()" />
                            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                <div *ngIf="f.password.errors.required">Password is required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <button [disabled]="loading" class="btn btn-primary">
                            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>           Login
                        </button>
                        </div>
                    </form>
                </div>
                <div class="card-footer" *ngIf="hasError">
                    <span style="color: #800000;">{{errorValue}}</span>
                </div>
            </div>
        </div>
    </div>
</div>